const NAME = "HISTORICAL_PERIODS";

export default NAME;
